import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { FIELD_PATH_KNOWN_LANGUAGES } from 'components/page/DatingProfile/DatingProfile.constants'
import { ProfileFieldType } from 'components/page/ProfileCommon/ProfileCommon.types'
import { ProfileFieldGeneric } from 'components/page/ProfileCommon/ProfileField/ProfileFieldGeneric'
import { LanguageActiveSvg } from 'components/presentational/svg/LanguageActiveSvg'
import { LanguageDefaultSvg } from 'components/presentational/svg/LanguageDefaultSvg'
import { GQLDatingProfileLexicalOptionType } from 'generated-graphql/graphql'

interface ProfileLanguageProps {
  data: any[] | null | undefined
  lexemes: GQLDatingProfileLexicalOptionType[]
}

export const ProfileLanguage: FC<ProfileLanguageProps> = ({
  data,
  lexemes,
}) => {
  return (
    <ProfileFieldGeneric
      iconDefault={<LanguageDefaultSvg />}
      iconActive={<LanguageActiveSvg />}
      description={
        <FormattedMessage id="profile.language" defaultMessage="Языки" />
      }
      fieldType={ProfileFieldType.WithTitle}
      lexemes={lexemes}
      data-name={FIELD_PATH_KNOWN_LANGUAGES}
      data={data}
      showDescriptionIfActive={true}
    />
  )
}
